import { render, staticRenderFns } from "./classic.vue?vue&type=template&id=2b9f5e38"
import script from "./classic.vue?vue&type=script&lang=js"
export * from "./classic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9f5e38')) {
      api.createRecord('2b9f5e38', component.options)
    } else {
      api.reload('2b9f5e38', component.options)
    }
    module.hot.accept("./classic.vue?vue&type=template&id=2b9f5e38", function () {
      api.rerender('2b9f5e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/main/classic.vue"
export default component.exports